import styled from '@emotion/styled';
import { PropsWithChildren } from 'react';

const StyledFacetsOverlayHeader = styled.div(({ theme }) => ({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	marginBottom: theme.space['10'],
}));

export type FacetsOverlayHeaderProps = PropsWithChildren<unknown>;

export const FacetsOverlayHeader = ({ children }: FacetsOverlayHeaderProps) => <StyledFacetsOverlayHeader>{children}</StyledFacetsOverlayHeader>;
